// Static site content — services, process, court configurator options.

export const SERVICES = [
  { slug: "court-resurfacing", title: "Court Resurfacing", short: "Full surface renewal", category: "resurfacing",
    intro: "Complete resurfacing systems that transform tired, cracked or faded courts into premium, long-lasting playing surfaces.",
    problem: "Old courts develop cracking, fading, ponding and surface wear that make them unsafe and unattractive.",
    solution: "We prepare the substrate, repair defects and apply a layered acrylic resurfacing system engineered for Australian conditions." },
  { slug: "basketball-court-resurfacing", title: "Basketball Court Resurfacing", short: "Home & club courts", category: "basketball",
    intro: "Custom basketball court resurfacing for homes, schools, clubs and community spaces across Sydney.",
    problem: "Worn basketball surfaces lose grip, colour and accurate markings.",
    solution: "A cushioned acrylic system with precision regulation line marking and your choice of custom colours." },
  { slug: "tennis-court-resurfacing", title: "Tennis Court Resurfacing", short: "Hard & acrylic courts", category: "tennis",
    intro: "Professional tennis court resurfacing delivering true, consistent ball response and premium finishes.",
    problem: "Cracked, slippery or faded tennis courts affect play and safety.",
    solution: "Crack repair, resurfacing and accurate tennis line marking in classic or custom colour schemes." },
  { slug: "netball-court-resurfacing", title: "Netball Court Resurfacing", short: "Club & school courts", category: "netball",
    intro: "Durable netball court resurfacing with accurate third-line marking and high-grip finishes.",
    problem: "Faded lines and slippery surfaces create injury risk for players.",
    solution: "High-traction acrylic coatings and precise netball marking to competition standards." },
  { slug: "multi-sport-court-resurfacing", title: "Multi-Sport Court Resurfacing", short: "Multiple sports, one court", category: "multi-sport",
    intro: "One surface, many sports — resurfacing with clear, colour-coded overlay markings.",
    problem: "Overlapping, confusing markings make multi-use courts hard to play on.",
    solution: "Colour-managed line systems that keep every sport legible on a single premium surface." },
  { slug: "school-court-resurfacing", title: "School Court Resurfacing", short: "Safe, vibrant play spaces", category: "school",
    intro: "Vibrant, safe and durable school court resurfacing with custom play markings and crests.",
    problem: "School courts wear quickly and lose their safety and appeal.",
    solution: "Hard-wearing coatings, custom colours, play games and school branding built to last." },
  { slug: "private-court-resurfacing", title: "Private Court Resurfacing", short: "Luxury home courts", category: "private",
    intro: "Bespoke private and residential court resurfacing with an architectural, premium finish.",
    problem: "Backyard courts age and no longer match the quality of the home.",
    solution: "A tailored resurfacing and custom design service that turns your court into a statement." },
  { slug: "commercial-court-resurfacing", title: "Commercial Court Resurfacing", short: "Clubs & facilities", category: "commercial",
    intro: "Commercial-grade resurfacing for clubs, gyms, apartments and sporting facilities.",
    problem: "High-traffic facilities need durable, compliant, low-maintenance surfaces.",
    solution: "Robust coating systems and scheduled delivery designed around your operation." },
  { slug: "court-line-marking", title: "Court Line Marking", short: "Precision markings", category: "line-marking",
    intro: "Precision sports line marking for every court type — the craft behind the Speedy name.",
    problem: "Inaccurate or faded lines undermine an otherwise good court.",
    solution: "Exacting, standards-based line marking with crisp edges and durable paint." },
  { slug: "custom-court-design", title: "Custom Court Design", short: "Colours, logos & graphics", category: "custom",
    intro: "Design-led custom courts with bespoke colours, centre logos, crests and graphics.",
    problem: "Standard courts feel generic and off-brand.",
    solution: "A design service that brings your colours, logo and identity to the surface." },
  { slug: "court-repainting", title: "Court Repainting", short: "Refresh & recolour", category: "repainting",
    intro: "Recolour and refresh existing courts without a full rebuild.",
    problem: "Colours fade and courts look dated well before the surface fails.",
    solution: "A repaint and re-mark service that restores colour, grip and pride." },
  { slug: "court-repairs", title: "Court Repairs", short: "Cracks & surface fixes", category: "repairs",
    intro: "Targeted crack repair, patching and surface correction to extend court life.",
    problem: "Cracks and defects spread and shorten a court's lifespan.",
    solution: "Specialist repair techniques that stabilise and prepare surfaces for coating." },
];

export const PROCESS = [
  { n: "01", title: "Inspect", text: "Understand the existing surface, its condition and your goals." },
  { n: "02", title: "Prepare", text: "Clean, repair and prepare the substrate for a lasting result." },
  { n: "03", title: "Resurface", text: "Apply the appropriate resurfacing and coating system." },
  { n: "04", title: "Customise", text: "Apply selected colours, layouts and graphics." },
  { n: "05", title: "Precision Mark", text: "Complete accurate, standards-based sports line marking." },
  { n: "06", title: "Handover", text: "Inspect, finish and present the completed court." },
];

export const COURT_TYPES = [
  "Basketball", "Tennis", "Netball", "Futsal", "Pickleball",
  "Multi-Sport", "School Courts", "Private Courts", "Commercial Courts", "Custom Courts",
];

export const SURFACE_CONDITIONS = [
  "Cracking", "Fading", "Ponding / drainage", "Peeling coating", "New slab", "Not sure",
];

export const COURT_COLOURS = [
  { name: "Obsidian", hex: "#141414" },
  { name: "Neon Gold", hex: "#FFD84A" },
  { name: "Court Blue", hex: "#2E6FB0" },
  { name: "Deep Teal", hex: "#0E5A57" },
  { name: "Championship Green", hex: "#1F7A3D" },
  { name: "Terracotta", hex: "#B5502E" },
  { name: "Slate Grey", hex: "#4A4E54" },
  { name: "Pure White", hex: "#F2F2F2" },
  { name: "Royal Purple", hex: "#5B3B8C" },
  { name: "Sunset Orange", hex: "#E4761B" },
];

export const IMAGES = {
  heroCourt: "/api/files/speedyz/uploads/0a2dfa8a-0f08-4fe1-a223-71ee3bd327c1.webp",
  archiveTennis: "/api/files/speedyz/uploads/9f55a100-4119-4504-9519-1e8320c1a6aa.webp",
  nightTennis: "/api/files/speedyz/uploads/f3a0755d-cd79-4350-8a68-0698175b22fd.webp",
  goldTexture: "https://images.pexels.com/photos/14331332/pexels-photo-14331332.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  speedyBball: "https://speedylinemarking.com.au/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-03-at-12.42.50_7ad23c9f.jpg",
  speedySport: "https://speedylinemarking.com.au/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-03-at-12.31.55_3ed2de3c.jpg",
  worn: "https://images.unsplash.com/photo-1729923332637-9d5767bfb2e5?crop=entropy&cs=srgb&fm=jpg&q=85",
  jordanBackyard: "/api/files/speedyz/uploads/0a2dfa8a-0f08-4fe1-a223-71ee3bd327c1.webp",
  backyardBlue: "/api/files/speedyz/uploads/15930ed0-48ec-4f38-99dd-924ada4b6717.jpg",
  tanHoop: "/api/files/speedyz/uploads/57f80f92-70d4-44d3-9a46-2cf8b8b405b2.webp",
  greenNetball: "/api/files/speedyz/uploads/3a705fec-4364-4f20-b71d-4f6bb344a7c9.webp",
  redSchool: "/api/files/speedyz/uploads/1fd3919a-e932-45f6-80fe-f1e9f663456a.webp",
  tennisAerial: "/api/files/speedyz/uploads/98acd981-5c8b-4b14-821a-2704a4316364.jpg",
  tennisAerialPortrait: "/api/files/speedyz/uploads/e9a68a6e-4fcd-43a0-bea4-9cb3b1a65d6d.jpg",
  tennisSingleAerial: "/api/files/speedyz/uploads/bdd1da01-7007-454b-805b-8f9664781508.jpg",
  tennisCourtside: "/api/files/speedyz/uploads/4b5108b7-d3b7-413e-89c1-39d6a980dd9c.jpg",
  tennisBaseline: "/api/files/speedyz/uploads/a8ad8655-5aca-42f7-a25f-c81e38bd3773.jpg",
  custom5Hero: "/api/files/speedyz/uploads/0a3481c8-a898-4f4e-a2ae-8684141a89b9.jpg",
  custom5Poolside: "/api/files/speedyz/uploads/3e0fea0b-560f-401c-98af-d98ec3f00f30.jpg",
  custom5Key: "/api/files/speedyz/uploads/6850d980-ac36-4ef6-b83c-9dff92343ea9.jpg",
  custom5Baseline: "/api/files/speedyz/uploads/6b630471-8ba5-430b-8d7b-18102861e9a9.jpg",
  schoolHallWide: "/api/files/speedyz/uploads/656e37b7-5119-4bb3-ba55-a199316de438.jpg",
  schoolCentreCircle: "/api/files/speedyz/uploads/e1ffb192-c82a-423e-8b59-3626dc8ada77.jpg",
  schoolMultiLines: "/api/files/speedyz/uploads/4d4ad5d2-a72e-4751-a6a3-cbc24af718ba.jpg",
  sdaHero: "/api/files/speedyz/uploads/4f302133-8986-4f86-9d51-d84c24a281fc.jpg",
  sdaBays: "/api/files/speedyz/uploads/a01fd049-cec5-4648-85d6-e22f8fef64f1.jpg",
  sdaNight: "/api/files/speedyz/uploads/56724aed-32a9-4cbd-8350-07102c40b30c.jpg",
  netballHero: "/api/files/speedyz/uploads/67541458-76ac-4c14-bd45-c7e4118f8fca.jpg",
  netballCourtsWide: "/api/files/speedyz/uploads/bba6da75-6151-44c0-b1f8-adf9238deb12.jpg",
  netballWetGloss: "/api/files/speedyz/uploads/0b751fe5-dfdc-4c39-98dc-787b3fa5f295.jpg",
  netballGoalThird: "/api/files/speedyz/uploads/690cfc58-6955-428f-8827-82dc423a53d1.jpg",
  netballWetWide: "/api/files/speedyz/uploads/b94ac94c-c862-4af3-aca5-8d1bd2206621.jpg",
  pickleballHero: "/api/files/speedyz/uploads/0e331272-bf6f-4535-a876-1586ed669938.jpg",
  pickleballCourt: "/api/files/speedyz/uploads/013c6de3-c745-493c-8e32-f9df94bc5219.jpg",
  pickleballBackyard: "/api/files/speedyz/uploads/fb1303a4-8737-4128-a65a-238040e90e59.jpg",
  pickleballBackyardWide: "/api/files/speedyz/uploads/27580f07-f33c-4630-8d47-6bb5f9846aec.jpg",
  pickleballBackyardHoop: "/api/files/speedyz/uploads/26606d0d-a688-46c4-9821-aa38b1442d9c.jpg",
  pickleballSchoolHoop: "/api/files/speedyz/uploads/4b4bddec-c3e7-4330-aa6f-67b594d7b9e9.webp",
  pickleballSchoolFence: "/api/files/speedyz/uploads/5cd86a51-076d-483f-b9b0-2a9ecdd8eabf.webp",
  pickleballIndoorTimber: "/api/files/speedyz/uploads/8a48164f-d87e-4353-8509-3741e3a61c7a.webp",
  pickleballSchoolPlay: "/api/files/speedyz/uploads/2c78a6ed-ad55-4775-9b5e-63f1073ac4b2.webp",
  pickleballIndoorTwin: "/api/files/speedyz/uploads/ca07fb0e-910b-498e-a7d0-2c8b9032b876.webp",
  pickleballIndoorSingle: "/api/files/speedyz/uploads/6fd88269-ed0a-4e54-8901-63a6b640d6bd.webp",
  pickleballNetTexture: "/api/files/speedyz/uploads/67c54925-624f-4fde-aac7-23c834549f02.webp",
  assessHero: "/api/files/speedyz/uploads/9a899fda-96ef-41f0-b677-b8aa00562e90.webp",
  assessCrack: "/api/files/speedyz/uploads/5a738263-0147-4d39-a73a-5c7450b7244b.webp",
  assessBirdbath: "/api/files/speedyz/uploads/53f3f9ad-c55b-43d1-906d-d30b2ffd0251.webp",
  assessPeeling: "/api/files/speedyz/uploads/8b0d961a-e32f-4ce7-87b4-8d15df598954.webp",
  assessPrep: "/api/files/speedyz/uploads/413445db-27cf-4c27-b634-88421a80fbe3.webp",
  assessPanel: "/api/files/speedyz/uploads/c86fc077-217b-4d79-b22c-0eff4d59887e.webp",
  slabHero: "/api/files/speedyz/uploads/8c129435-222e-400a-8478-06cc32e4c689.webp",
  slabHierarchy: "/api/files/speedyz/uploads/09303f74-dae4-4ac9-8b3e-42e99e997e44.webp",
  slabComparison: "/api/files/speedyz/uploads/5132b47a-bb00-4a95-b088-b939dc90cf14.webp",
  paletteMinimalist: "/api/files/speedyz/uploads/93424bd8-3ed1-4b87-bb96-19c31fb30aa4.webp",
  paletteCoastal: "/api/files/speedyz/uploads/5ef1ce12-d524-4a04-b98d-290ce1b6349e.webp",
  paletteArena: "/api/files/speedyz/uploads/dc601cc3-9cd0-417b-ae8b-c8817ea863a1.webp",
  slabGrinding: "/api/files/speedyz/uploads/4ad5845c-86e2-4186-8bd1-9f623521c352.webp",
  slabCrackFill: "/api/files/speedyz/uploads/d2318c54-5602-4400-8af4-401d66be6411.webp",
  slabResurfacer: "/api/files/speedyz/uploads/cd659618-d668-4183-a0e4-3239ba7071e6.webp",
  tanTeal: "/api/files/speedyz/uploads/9f55a100-4119-4504-9519-1e8320c1a6aa.webp",
  prepHero: "/api/files/speedyz/uploads/da4090aa-fb37-46c8-b74e-9b67e49ed3f9.webp",
  prepFailure: "/api/files/speedyz/uploads/92d5940a-cf5b-4dab-ade9-22a5df21ddca.webp",
  prepGrinding: "/api/files/speedyz/uploads/ab755dbe-7dcb-4ccc-98ed-86ad8ec6eb46.webp",
  prepWashing: "/api/files/speedyz/uploads/5eeaa294-f559-4e1e-9e45-21c31a9b80a0.webp",
  prepCrack: "/api/files/speedyz/uploads/28d454bd-327c-4cdf-9c3c-89327805c601.webp",
  prepBirdbath: "/api/files/speedyz/uploads/0cfee5a2-0859-476e-83d4-73e03b9216fd.webp",
  prepPrimer: "/api/files/speedyz/uploads/dfc79a13-4e28-469e-aafa-7107e556c673.webp",
  prepLines: "/api/files/speedyz/uploads/5d2d11e0-2db7-42b6-a377-4a2a54e82430.webp",
  repairHero: "/api/files/speedyz/uploads/55f36a09-13fc-47cc-b60b-325bc9b9477a.webp",
  repairCrackTypes: "/api/files/speedyz/uploads/fb85f5dd-8114-4d0a-8c07-e87e7e677fd6.webp",
  repairRouting: "/api/files/speedyz/uploads/5b829060-657b-4ce5-a581-e5522a7a7c42.webp",
  repairCrackFill: "/api/files/speedyz/uploads/8acfa6ed-ccb2-4e6c-a262-53d85a91c9cb.webp",
  repairExpansionJoint: "/api/files/speedyz/uploads/c8abbf60-602c-4d81-a1b4-007da54d0ff8.webp",
  repairFloodTest: "/api/files/speedyz/uploads/621d342b-31cb-4e93-8f9d-274392a24ed1.webp",
  repairPatch: "/api/files/speedyz/uploads/521e0d7f-a419-451c-9ed1-86c61ec62793.webp",
  repairWornCoatings: "/api/files/speedyz/uploads/e5cd2e62-94d8-433e-9343-1532cfe90097.webp",
  repairAsphaltResurfacer: "/api/files/speedyz/uploads/6d9970dd-3f37-479c-8b0f-b1b2cb317295.webp",
  repairLines: "/api/files/speedyz/uploads/28254abf-9c7e-406d-8e61-c8ac88ae9961.webp",
  pbHero: "/api/files/speedyz/uploads/7e904f94-1f5d-43e2-a274-d052f524dc10.webp",
  pbSubstrate: "/api/files/speedyz/uploads/50507902-48f5-4376-a4b4-49e69ac6e180.webp",
  pbLayers: "/api/files/speedyz/uploads/5bcedba2-97c6-45fb-9408-b8e841575e14.webp",
  pbPaletteClassic: "/api/files/speedyz/uploads/6bd8bdec-e947-4d9e-8bd5-db0df1003829.webp",
  pbPaletteModern: "/api/files/speedyz/uploads/2308c7a1-5f96-4650-bcfc-a02730b73442.webp",
  pbPaletteGreen: "/api/files/speedyz/uploads/4251e379-2ef4-40d6-829e-f97f1da16239.webp",
  pbHierarchy: "/api/files/speedyz/uploads/22e2942d-3f49-4441-907b-9bbe8ce745d5.webp",
  pbDedicated: "/api/files/speedyz/uploads/c87cce0d-e0d0-4550-8966-57b78c00c58f.webp",
  pbConversion: "/api/files/speedyz/uploads/62b95313-96a8-4453-8812-acd6c3fce198.webp",
  pbEnvelope: "/api/files/speedyz/uploads/672d9de7-e5e7-458a-aaca-24de3ee96db4.webp",
  pbDrainage: "/api/files/speedyz/uploads/e2ddd7fd-8ee4-4ada-b709-7de3adba69fa.webp",
  pbCuring: "/api/files/speedyz/uploads/d0efe82d-bc61-43d2-bca2-4db67be35974.webp",
  bbHero: "/api/files/speedyz/uploads/b938e3d3-4a4d-4ce1-acaf-8345948efc09.webp",
  bbSchool: "/api/files/speedyz/uploads/08f2acf4-add4-44db-bb9a-eafda6644a06.webp",
  bbCouncil: "/api/files/speedyz/uploads/9e24522d-a778-4bbf-b5e3-490271a7ff60.webp",
  bbBackyard: "/api/files/speedyz/uploads/d92c44eb-f089-4742-b9eb-0d90f8eac538.webp",
  bbFullCourt: "/api/files/speedyz/uploads/e511df62-9f18-4e91-8e34-3ba2e0716477.webp",
  bbHalfCourt: "/api/files/speedyz/uploads/549a905e-f5c3-4576-85d6-ba7eff15b8be.webp",
  bbCustom: "/api/files/speedyz/uploads/eefbade0-99aa-447b-9ad0-4f4ba1a706e8.webp",
  bbKeyProportions: "/api/files/speedyz/uploads/1ad5230e-dd12-496e-b4e9-0e2904309e80.webp",
  bbMultiSport: "/api/files/speedyz/uploads/63510cae-1276-4112-b9f8-3008bcb11563.webp",
  bbColourZones: "/api/files/speedyz/uploads/19b8d06b-9037-4ad2-95cd-c10e9ff94e48.webp",
  bbQuoteScope: "/api/files/speedyz/uploads/754512a5-31ec-4d8d-a24d-c7efc4526507.webp",
  bbHandover: "/api/files/speedyz/uploads/4282c628-5ace-40eb-9034-f90c1aa43ba0.webp",
  tnHero: "/api/files/speedyz/uploads/659be9b1-0c22-4890-8654-78e5059492b3.webp",
  tnPatchwork: "/api/files/speedyz/uploads/aa4c5276-e182-4a6e-8b42-645fe68c8025.webp",
  tnStage1: "/api/files/speedyz/uploads/34d12369-1f85-4755-99c8-5b2d05a9d226.webp",
  tnStage2: "/api/files/speedyz/uploads/ee59bc3d-e8ad-4bc3-a860-40eb30f3d6f1.webp",
  tnStage3: "/api/files/speedyz/uploads/ee701540-e909-4875-8585-c462d0b3110c.webp",
  tnReflective: "/api/files/speedyz/uploads/8bab5d24-ed19-4b06-8dba-aef70d77a701.webp",
  tnDelamination: "/api/files/speedyz/uploads/c3fcbc67-87ab-403c-a65f-a7d8efe55f46.webp",
  tnBirdbath: "/api/files/speedyz/uploads/8a5598f3-b81c-40e9-a8bd-c2d9126e9901.webp",
  tnAggregate: "/api/files/speedyz/uploads/2311e9ef-fde7-4e32-936d-f659f41c4c64.webp",
  tnMembrane: "/api/files/speedyz/uploads/2856a544-2807-4b5f-a459-b140b9aa4da4.webp",
  tnPickleball: "/api/files/speedyz/uploads/fb69c6d1-0197-4293-ab6e-b18e8e0908a2.webp",
  tnAccess: "/api/files/speedyz/uploads/bc3895c8-7637-4dbe-b60f-16f123671895.webp",
  nbHero: "/api/files/speedyz/uploads/601f955b-a680-47f4-a7cb-d38e3e001c59.webp",
  nbTraction: "/api/files/speedyz/uploads/e8f8c8be-167a-4618-84a3-c2e2efd63dd7.webp",
  nbGeometry: "/api/files/speedyz/uploads/408384f6-e82b-4cfe-81d9-cec4bba24fe0.webp",
  nbPostSleeve: "/api/files/speedyz/uploads/5bf1d1b9-411c-4930-9abc-9778b7550233.webp",
  nbRunoff: "/api/files/speedyz/uploads/f8ad81d1-2272-44bd-b08d-7f3ee23d761c.webp",
  nbDrainage: "/api/files/speedyz/uploads/af11a32d-e306-4903-92fe-dd429c607d13.webp",
  nbExpansionJoint: "/api/files/speedyz/uploads/ece20f95-c6c0-4cfe-874e-c72be951b746.webp",
  nbMultiSport: "/api/files/speedyz/uploads/3b08d11d-76d7-4c43-a53e-79c3887382b3.webp",
  nbColours: "/api/files/speedyz/uploads/05f5d4b1-3ada-49cd-a996-da12dad76075.webp",
  nbBaseCoat: "/api/files/speedyz/uploads/aa2e1c91-3272-417d-a896-757f09a170b7.webp",
  nbLines: "/api/files/speedyz/uploads/ae4e550b-6e94-4fc5-8f00-2405b010c03b.webp",
  btHero: "/api/files/speedyz/uploads/c411d30f-a651-4f77-a352-d373d5996f78.webp",
  btWear: "/api/files/speedyz/uploads/c4c10c50-1685-4ef2-80de-bb68bccce7c8.webp",
  btDay1: "/api/files/speedyz/uploads/84c1eb83-88ab-4b70-a5d2-b66de7d4146a.webp",
  btDay3: "/api/files/speedyz/uploads/2aa9b6cf-282a-4390-9a15-162d99502937.webp",
  btDay6: "/api/files/speedyz/uploads/ac267a44-ee2a-46b8-a1f7-b1769bde798e.webp",
  btWeather: "/api/files/speedyz/uploads/b3325894-b75e-45e4-91b3-210e4a6d31c0.webp",
  btIsolation: "/api/files/speedyz/uploads/c1e807a6-e7ac-4bb1-ac4d-d9e1592f4e71.webp",
  btPickleball: "/api/files/speedyz/uploads/7e62b3d6-98e8-4ac6-94c3-fd69eb4cacd7.webp",
  btHierarchy: "/api/files/speedyz/uploads/3661d411-f290-40f2-bcac-9e6b0f83eca2.webp",
  btScale: "/api/files/speedyz/uploads/94170e6e-37d0-401d-b04e-cf1abf8b18be.webp",
  mcHero: "/api/files/speedyz/uploads/0d4c2f71-bac1-4e24-991f-85f8129f2d52.webp",
  mcThreeTone: "/api/files/speedyz/uploads/d3b82b12-19f9-43f4-98d9-b1cd0965e060.webp",
  mcBallVisibility: "/api/files/speedyz/uploads/54679be1-1ccf-4c41-a4de-6b80c0181208.webp",
  mcHierarchy: "/api/files/speedyz/uploads/3cc698fe-63ac-4382-a6d4-a7c3c00f346d.webp",
  mcSchoolColours: "/api/files/speedyz/uploads/9da4b04b-1e1c-4a07-89d0-0d85848854d5.webp",
  mcOffsetZones: "/api/files/speedyz/uploads/f02b15f7-65a4-42bf-8b46-e6f43ca5b38b.webp",
  mcDedicated: "/api/files/speedyz/uploads/c8d00692-c4dc-4ebd-ba9a-bc2fd51f5dac.webp",
  mcGhostLines: "/api/files/speedyz/uploads/ed0c428d-0429-42a2-aebe-25b9f521a631.webp",
  mcPortableNet: "/api/files/speedyz/uploads/5992152d-fc3e-40a8-9427-a3d7a6a52df5.webp",
  mcFootprint: "/api/files/speedyz/uploads/dee0b724-7b24-4c8f-b3a2-d27854fae429.webp",
  mcAccess: "/api/files/speedyz/uploads/fc2baa43-37ae-4bb5-a029-d61f7f6ec2f4.webp",
  mcPrep: "/api/files/speedyz/uploads/2af5cf34-ca59-4905-a476-50d9a99157bf.webp",
};

// Real Google reviews of Speedy Line Marking (parent brand).
export const TESTIMONIALS = [
  { quote: "Very professional service. Quick, efficient and competitive price.", name: "Jacques Phelipot" },
  { quote: "Affordable and reliable, Nick and team did a great job.", name: "Shine Preschool" },
  { quote: "It only took 1 telephone call, and the very next day, had a very, very competitive quote and a few days later the job was completed in a very professional manner.", name: "Tony Agamalis" },
  { quote: "Nick and the team have been to our site multiple times, providing a professional service with exceptional results. Great pricing and very punctual.", name: "Callum Caspers" },
];

// Real service areas from the Speedy Line Marking network.
export const SERVICE_AREAS = [
  "Sydney CBD", "Sutherland Shire", "Liverpool", "Minto", "Menangle",
  "Wollongong", "Newcastle", "Mossvale", "Kangaroo Valley", "Queanbeyan",
  "Goulburn", "Nowra", "Canberra", "Mollymook",
];

export const CATEGORIES = ["all", "basketball", "tennis", "netball", "school", "multi-sport", "private", "commercial", "custom"];

// The Speedy Method — the parent-brand 4-step system, reframed for court resurfacing.
export const SPEEDY_METHOD = [
  { n: "01", title: "Consultation", icon: "MessageSquare", slug: "consultation",
    text: "We start by understanding your court, goals and budget — a detailed on-site assessment of surface, drainage, cracking and compliance." },
  { n: "02", title: "Preparation", icon: "ClipboardList", slug: "preparation",
    text: "We design a tailored resurfacing plan and present a clear, itemised quote — colours, layout, system and timeline. No surprises." },
  { n: "03", title: "Execution", icon: "Target", slug: "execution",
    text: "Our crew prepares the substrate, repairs defects and lays a premium layered acrylic system with millimetre-perfect line marking." },
  { n: "04", title: "Final Inspection", icon: "BadgeCheck", slug: "final-inspection",
    text: "A full quality check against Australian standards, then handover of a court built to perform and impress for years." },
];

// Why Speedy Resurfacing — trust differentiators (mirrors parent-brand "why us").
export const WHY_US = [
  { title: "Round-the-Clock Service", icon: "Clock",
    text: "Court work that fits your schedule — we operate day and night to deliver on time, every time." },
  { title: "CM3 Certified Contractor", icon: "ShieldCheck",
    text: "Robust health & safety management, fully licensed and insured to Australian OHS standards." },
  { title: "Extensive Experience", icon: "Award",
    text: "Years resurfacing and marking Sydney's courts — trusted by schools, clubs and councils." },
  { title: "Premium Materials", icon: "Gem",
    text: "Only high-grade, weather-durable coatings and Australian-standard paints. No compromise." },
  { title: "Customer-First Approach", icon: "HeartHandshake",
    text: "Transparent from consultation to handover — your court, your vision, exceeded." },
];

// Trusted-by clients. Add a `logo` path (e.g. "/brand/clients/name.png") to show real logos.
export const CLIENTS = [
  { name: "Schools & Colleges" },
  { name: "Sports Clubs" },
  { name: "Local Councils" },
  { name: "Childcare Centres" },
  { name: "Private Estates" },
];
